import React from "react"
import ProjectsContainer from "../components/Projects/ProjectsContainer"

function ProjectsPage() {
  return <ProjectsContainer />
}

export default ProjectsPage
